import React, {
  useEffect,
} from 'react';

import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import {
  Navigate, useParams,
} from 'react-router';

import PageContent from '../../components/PageContent';
import { LoadingWrapper } from '../../components/PageLayout';
import Tabs from '../../components/Tabs';
import { useGetLeadQuery } from '../../services/leads';
import useTab from '../../utils/react/hooks/useTab';

import { ContentContainer, PageContainer } from './index.styles';
import ProfileTab from './ProfileTab';
import SettingsTab from './SettingsTab';
import TopBar from './TopBar';

const TAB_OPTIONS = [
  {
    key: 'profile',
    label: 'Profile',
    icon: <PersonOutlinedIcon />,
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: <SettingsOutlinedIcon />,
  },
];

interface AdminLeadPageContentsProps {
  leadType: string,
  leadId: string,
}

const AdminLeadPageContents = ({ leadType, leadId }: AdminLeadPageContentsProps) => {
  const { data: lead,
    isLoading: isLeadDataLoading } = useGetLeadQuery(
    { type: leadType, leadId },
  );

  const [tab, setTab] = useTab({ default: TAB_OPTIONS[0].key });

  // Update page title
  useEffect(() => {
    if (lead?.data.name) {
      document.title = `${lead?.data.name} | Cognito Leads`;
    }
  }, [lead]);

  const handleTabChange = (key: string) => {
    setTab(key);
  };

  return (
    <PageContent>
      <PageContainer>
        <LoadingWrapper loading={isLeadDataLoading}>
          <ContentContainer>
            <TopBar lead={lead?.data} />
            <Tabs options={TAB_OPTIONS} selectedKey={tab} onChange={handleTabChange} />
            {
              tab === 'profile' && <ProfileTab lead={lead?.data} leadMetadata={lead?.metadata} />
            }
            {
              tab === 'settings' && <SettingsTab lead={lead?.data} />
            }
          </ContentContainer>
        </LoadingWrapper>
      </PageContainer>
    </PageContent>
  );
};

const AdminLeadPage = () => {
  const { leadType, leadId } = useParams();

  if (leadType && leadId) {
    return (
      <AdminLeadPageContents
        leadType={leadType}
        leadId={leadId}
      />
    );
  }

  // If no userId is provided, return to Leads page
  return <Navigate replace to="/admin/leads" />;
};
export default AdminLeadPage;
